import { IWalletBalance } from "models/Home";
import { RootState } from "store";

export const selectCardSettings = (state: RootState) =>
  state.homeState.cardSettings as IWalletBalance[];

export const selectWalletBalance = (state: RootState) => state.homeState.walletBalance;
